<template>
    <section class="mainGrp">
        <div class="wrap wrap01 center">
            <div class="flexGrp">
                <div class="flex_box flex_box_facility">
                    <h3>医療・福祉施設</h3>
                    <div class="category categorytp">
                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Medical' } }">
                                <p>医療・福祉施設</p><img :src="img_common_path + linklogo_Medical" alt="医療・福祉施設">
                            </router-link>
                        </div>

                    </div>
                </div>
                <div class="flex_box flex_box_facility02">
                    <h3>教育・保育施設</h3>
                    <div class="category categorytp">
                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Education' } }">
                                <p>教育・保育施設</p><img :src="img_common_path + linklogo_Education" alt="教育・保育施設">
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="flex_box flex_box_office">
                    <h3>オフィススペース</h3>
                    <div class="category categorytp">

                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Desk' } }">
                                <p>デスク・デスク周辺</p><img :src="img_common_path + linklogo_Desk" alt="デスク・デスク周辺">
                            </router-link>
                        </div>

                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Chair' } }">
                                <p>事務用チェア</p><img :src="img_common_path + linklogo_Chair" alt="事務用チェア">
                            </router-link>
                        </div>

                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Storage' } }">
                                <p>収納・棚・ラック</p><img :src="img_common_path + linklogo_Storage" alt="収納・棚・ラック">
                            </router-link>
                        </div>

                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Partition' } }">
                                <p>パーティション</p><img :src="img_common_path + linklogo_Partition" alt="パーティション">
                            </router-link>
                        </div>

                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Counter' } }">
                                <p>カウンター</p><img :src="img_common_path + linklogo_Counter" alt="カウンター">
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="flex_box flex_box_meet">
                    <h3>ミーティング・リフレッシュ・応接スペース</h3>
                    <div class="category categorytp">

                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Table' } }">
                                <p>テーブル</p><img :src="img_common_path + linklogo_Table" alt="テーブル">
                            </router-link>
                        </div>

                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'MeetingChair' } }">
                                <p>ミーティングチェア</p><img :src="img_common_path + linklogo_MeetingChair" alt="ミーティングチェア">
                            </router-link>
                        </div>

                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Lobby' } }">
                                <p>応接・ロビーチェア</p><img :src="img_common_path + linklogo_Lobby" alt="応接・ロビーチェア">
                            </router-link>
                        </div>

                        <div class="item">
                            <div class="item">
                                <router-link
                                    :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Board' } }">
                                    <p>ボード</p><img :src="img_common_path + linklogo_Board" alt="ボード">
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex_box flex_box_accessory">
                    <h3>オフィスアクセサリー<br><span>(エントランス / コンテナ・台車 / 災害対策用品)</span></h3>
                    <div class="category categorytp">

                        <div class="item">
                            <router-link
                                :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Accessory' } }">
                                <img :src="img_common_path + linklogo_Accessory" alt="オフィスアクセサリー">
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="flex_box flex_box_outlet">
                    <h3>OUTLET</h3>
                    <div class="outlet_banner">
                        <router-link
                            :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: 'Outlet' } }"><img
                                :src="img_common_path + linklogo_Outlet" alt="数量限定！お得なOUTLET!今すぐチェック!"></router-link>
                    </div>
                </div>









            </div>

        </div>
    </section>
</template>
<script>
import { ref } from 'vue';
import axios from 'axios'
export default {
    name: 'homecategory',
    setup() {
        const img_common_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/common/"
        const linklogo_Outlet = "outlet_banner.png"

        const linklogo_Desk = "desk_01.png"
        const linklogo_Chair = "officechair_01.png"
        const linklogo_Storage = "office_03.png"
        const linklogo_Partition = "partition_01.png"
        const linklogo_Counter = "counter_01.png"

        const linklogo_Table = "meet_01.png"
        const linklogo_MeetingChair = "meetingchair_01.png"
        const linklogo_Lobby = "lobbychair_01.png"
        const linklogo_Board = "board_01.png"

        const linklogo_Education = "facility_01.png"
        const linklogo_Medical = "facility_02.png"

        const linklogo_Accessory = "accessory_01.png"

        const validity_period = ref()
        async function getData() {
            const console_json = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/console.json"
            let data = await axios.get(console_json)

            validity_period.value = data.data[0].validity_period
            // console.log(validity_period)
        }
        getData()

        return {
            img_common_path,
            linklogo_Outlet,

            linklogo_Desk,
            linklogo_Chair,
            linklogo_Storage,
            linklogo_Partition,
            linklogo_Counter,

            linklogo_Table,
            linklogo_MeetingChair,
            linklogo_Lobby,
            linklogo_Board,

            linklogo_Education,
            linklogo_Medical,

            linklogo_Accessory,

            validity_period
        }
    },

}
</script>